module.exports = __webpack_public_path__ + "img/group-26.84c4633.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/group-26.svg
// module id = ./assets/group-26.svg
// module chunks = 13